import { createContext } from 'react';

export const PortalContainerContext = createContext<HTMLElement | null>(null);
